<template>
  <el-dialog
    :visible.sync="showDialog"
    @close="close"
    @open="open(statistics)"
    :showClose="showClo"
    top="11vh"
  >
    <!-- 单词详情弹出框 -->
    <div class="pop_words">
      <!-- 词汇 -->
      <div class="pop_words_3">
        <table class="word_list" cellspacing="0" style="width: 260px;height: 380px;margin-bottom: 37px;">
          <tr class="word_list_head">
            <td>实词</td>
            <td class="notionalN"></td>
          </tr>
          <tr>
            <td>名词&nbsp;[<span class="noun_count"></span>]</td>
            <td class="noun_list"></td>
          </tr>
          <tr>
            <td>代词&nbsp;[<span class="pron_count"></span>]</td>
            <td class="pron_list"></td>
          </tr>
          <tr>
            <td>形容词&nbsp;[<span class="adj_count"></span>]</td>
            <td class="adj_list"></td>
          </tr>
          <tr>
            <td>副词&nbsp;[<span class="adv_count"></span>]</td>
            <td class="adv_list"></td>
          </tr>
          <tr>
            <td>动词&nbsp;[<span class="verb_count"></span>]</td>
            <td class="verb_list"></td>
          </tr>
          <tr>
            <td>数词&nbsp;[<span class="num_count"></span>]</td>
            <td class="num_list"></td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
          <tr class="word_list_head">
            <td>虚词</td>
            <td class="functionN"></td>
          </tr>
          <tr>
            <td>冠词&nbsp;[<span class="art_count"></span>]</td>
            <td class="art_list"></td>
          </tr>
          <tr>
            <td>介词&nbsp;[<span class="prep_count"></span>]</td>
            <td class="prep_list"></td>
          </tr>
          <tr>
            <td>连词&nbsp;[<span class="conj_count"></span>]</td>
            <td class="conj_list"></td>
          </tr>
          <tr>
            <td>感叹词&nbsp;[<span class="interj_count"></span>]</td>
            <td class="interj_list"></td>
          </tr>
          <tr>
            <td colspan="2">&nbsp;</td>
          </tr>
        </table>

        <div class="flex-item" style="margin-left: 20px;height: 266px;">
          <div class="echarts_title">
            <h2>年级词汇数量分布</h2>
          </div>
          <div class="echrts_div" id="echarts_bar"></div>
        </div>
      </div>
      <div class="pop_words_3">
        <table class="otherword_list" cellspacing="0" style="margin-bottom: 35px;">
          <thead>
            <tr class="word_list_head">
              <td>过渡词</td>
              <td class="conjunction_word_count"></td>
            </tr>
          </thead>
          <tbody class="conjunction_word_list" style="height:285px"></tbody>
        </table>
        <table class="otherword_list" cellspacing="0">
          <thead>
            <tr class="word_list_head">
              <td>停止词</td>
              <td class="stopwords_count"></td>
            </tr>
          </thead>
          <tbody class="stopwords_list" style="height:285px"></tbody>
        </table>
        <!-- <table class="otherword_list" cellspacing="0">
          <thead>
            <tr class="word_list_head">
              <td>外来词</td>
              <td class="foreign_count"></td>
            </tr>
          </thead>
          <tbody class="foreign_list" style="height:103px"></tbody>
        </table> -->
      </div>
      <div class="pop_words_3">
        <!-- 句子 -->
        <div class="sentence_list">
          <div class="word_list_head">
            简单句&nbsp;[<span class="sentence_simple_count"></span>]
          </div>
          <ul class="sentence_simple_list" style="height: 132px;"></ul>
        </div>
        <div class="sentence_list">
          <div class="word_list_head">
            并列句&nbsp;[<span class="sentence_compound_count"></span>]
          </div>
          <ul class="sentence_compound_list"></ul>
        </div>
        <div class="sentence_list">
          <div class="word_list_head">
            复合句&nbsp;[<span class="sentence_complex_count"></span>]
          </div>
          <ul class="sentence_complex_list"></ul>
        </div>
        <div class="sentence_list">
          <div class="word_list_head">
            并列复合句&nbsp;[<span
              class="sentence_compound_complex_count"
            ></span
            >]
          </div>
          <ul class="sentence_compound_complex_list"></ul>
        </div>
      </div>
      <div class="pop_words_3">
        <!-- 文章结构 -->
        <div class="flex-item" style="width: 300px;">
          <div class="echarts_title">
            <h2>单词长度的数量分布</h2>
          </div>
          <div class="echrts_div1" id="echarts_pie1"></div>
        </div>
        <div class="flex-item" style="width: 300px;">
          <div class="echarts_title">
            <h2>句子长度的数量分布</h2>
          </div>
          <div class="echrts_div1" id="echarts_pie2"></div>
        </div>
        <div class="flex-item" style="width: 300px;">
          <div class="echarts_title">
            <h2>句型占比</h2>
          </div>
          <div class="echrts_div1" id="echarts_pie3"></div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      showDialog: false,
      showClo: false,
      option: {},
      option1: {},
      option2: {},
      option3: {}
    };
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    statistics: {
      type: Object,
      default: () => {
        return {};
      }
    },
    conceal: Function
  },
  watch: {
    show(val) {
      if (val) {
        this.showDialog = val;
      }
    }
  },
  mounted() {},
  methods: {
    close() {
      this.showDialog = false;
      this.conceal();
      $(".sentence_list ul li").remove();
      $(".word_list_details").remove();
    },
    open(data) {
      this.$nextTick(() => {
        this.wordSentence(data);
        this.wordEchart(data);
        this.wordEchart1();
      });
    },
    //展示单词句子列表
    wordSentence(data) {
      //实词虚词的数量计算
      $(".notionalN").html(
        data.noun_count +
          data.pron_count +
          data.adj_count +
          data.adv_count +
          data.verb_count +
          data.num_count
      );
      $(".functionN").html(
        data.art_count + data.prep_count + data.conj_count + data.interj_count
      );
      //词性列表
      $(".word_list tr td,.word_list tr td span").each(function() {
        for (let key in data) {
          if ($(this).prop("class") == key) {
            if (data[key].length >= 2) {
              $(this).html(data[key].join(" ,  "));
              $(this).attr("title", data[key].join(" ,  "));
            } else {
              $(this).html(data[key]);
              $(this).attr("title", "");
            }
          }
        }
      });
      //其他词性
      $(".otherword_list tr td").each(function() {
        for (let key in data) {
          if ($(this).prop("class") == key) {
            $(this).html(data[key]);
          }
        }
      });
      let conjunction_word_countN = 0;
      for (let i = 0; i < data.conjunction_word_count.length; i++) {
        conjunction_word_countN += data.conjunction_word_count[i];
      }
      $(".conjunction_word_count").html(conjunction_word_countN);
      $(".otherword_list tbody").each(function() {
        for (let key in data) {
          for (let item in data[key]) {
            if ($(this).prop("class") == key) {
              $(this).append(
                '<tr class="word_list_details"><td style="width:100px;text-align:center;">' +
                  (item * 1 + 1) +
                  '</td><td style="width:125px;display:inline-block;text-align:center;">' +
                  data[key][item] +
                  "</td></tr>"
              );
            }
          }
        }
      });
      //句型列表
      $(".sentence_list div span").each(function() {
        for (let key in data) {
          if ($(this).prop("class") == key) {
            $(this).html(data[key]);
          }
        }
      });
      $(".sentence_list ul").each(function() {
        // $('.sentence_list ul li').remove()
        for (let key in data) {
          for (let item in data[key]) {
            if ($(this).prop("class") == key) {
              $(this).append("<li><span style='display: inline-block;width: 10px;height: 10px;background: #6098fe;margin-right: 5px;'></span>" + data[key][item] + "</li>");
            }
          }
        }
      });
    },
    //展示图表
    wordEchart(data) {
      let echarts_bar = document.getElementById("echarts_bar");
      let myChart = this.$echarts.init(echarts_bar);
      this.option = {
        color: "#6198fe",
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            rotate: 45
          },
          data: ["小学", "七年级", "八年级", "九年级", "高年级"]
        },
        yAxis: {
          show: false
        },
        series: [
          {
            data: [
              data.lower_7_count,
              data.grade_7_count,
              data.grade_8_count,
              data.grade_9_count,
              data.higher_9_count
            ],
            type: "bar",
            barWidth: 20,
            label: {
              show: true,
              position: "top",
              formatter: "{c}"
            }
          }
        ]
      };
      myChart.setOption(this.option, true);
      let echarts_pie1 = document.getElementById("echarts_pie1");
      let myChart1 = this.$echarts.init(echarts_pie1);
      this.option1 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["<4个字母", "4~6个", "7~10个", "11~15个", ">15个"]
        },
        series: [
          {
            name: "单词数",
            type: "pie",
            radius: ["55%", "75%"],
            center: ["72%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = [
                    "#bcdaff",
                    "#8dc1fe",
                    "#6198fe",
                    "#3f89f9",
                    "#3377fe"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: data.long_word_4less, name: "<4个字母" },
              { value: data.long_word_4to6, name: "4~6个" },
              { value: data.long_word_7to10, name: "7~10个" },
              { value: data.long_word_11to15, name: "11~15个" },
              { value: data.long_word_16more, name: ">15个" }
            ]
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart1.setOption(this.option1, true);
      let echarts_pie2 = document.getElementById("echarts_pie2");
      let myChart2 = this.$echarts.init(echarts_pie2);
      this.option2 = {
        legend: {
          orient: "vertical",
          x: "left",
          data: [
            "1~5个单词",
            "6~10个",
            "11~15个",
            "16~20个",
            "21~25个",
            "26~30个",
            "31~40个",
            "41~50个",
            ">50个"
          ]
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        series: [
          {
            name: "句子数",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["72%", "58%"],
            avoidLabelOverlap: false,
            itemStyle: {
              normal: {
                color: function(params) {
                  let colorList = [
                    "#e4efff",
                    "#bcdaff",
                    "#8dc1fe",
                    "#6198fe",
                    "#3377fe",
                    "#084ecf",
                    "#083c9e",
                    "#0d2d6a",
                    "#0a1d41"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "14",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: data.sentence_word_1to5, name: "1~5个单词" },
              { value: data.sentence_word_6to10, name: "6~10个" },
              { value: data.sentence_word_11to15, name: "11~15个" },
              { value: data.sentence_word_16to20, name: "16~20个" },
              { value: data.sentence_word_21to25, name: "21~25个" },
              { value: data.sentence_word_26to30, name: "26~30个" },
              { value: data.sentence_word_31to40, name: "31~40个" },
              { value: data.sentence_word_41to50, name: "41~50个" },
              { value: data.sentence_word_51more, name: ">50个" }
            ]
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart2.setOption(this.option2, true);
      let echarts_pie3 = document.getElementById("echarts_pie3");
      let myChart3 = this.$echarts.init(echarts_pie3);
      this.option3 = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "句型占比",
            type: "pie",
            radius: "60%",
            center: ["50%", "55%"],
            data: [
              { value: data.sentence_simple_count, name: "简单句" },
              { value: data.sentence_compound_count, name: "并列句" },
              { value: data.sentence_complex_count, name: "复合句" },
              {
                value: data.sentence_compound_complex_count,
                name: "并列复合句"
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                color: function(params) {
                  //自定义颜色
                  let colorList = ["#bcdaff", "#8dc1fe", "#6198fe", "#3377fe"];
                  return colorList[params.dataIndex];
                }
              }
            }
          }
        ]
      };
      myChart3.setOption(this.option3, true);
    },
    //刷新图表
    wordEchart1() {
      let echarts_bar = document.getElementById("echarts_bar");
      echarts_bar.removeAttribute("_echarts_instance_");
      let echarts_pie1 = document.getElementById("echarts_pie1");
      echarts_pie1.removeAttribute("_echarts_instance_");
      let echarts_pie2 = document.getElementById("echarts_pie2");
      echarts_pie2.removeAttribute("_echarts_instance_");
      let echarts_pie3 = document.getElementById("echarts_pie3");
      echarts_pie3.removeAttribute("_echarts_instance_");
    }
  }
};
</script>
<style>
/* .el-dialog {
        width: 1450px;
        height: 780px;
    }
    .el-dialog__body {
        padding: 0 20px !important;
    } */
</style>
<style scoped>
/deep/ .el-dialog {
  width: 1450px;
  height: 780px;
}
/deep/ .el-dialog__body {
  padding: 0 20px !important;
}
table {
  /* width:100px;   */
  table-layout: fixed; /* 只有定义了表格的布局算法为fixed，下面td的定义才能起作用。 */
}
td {
  width: 100%;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}
ul {
  text-align: left;
  padding: 0;
}
ul li {
  list-style: none;
}
.flex-item {
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
  margin: 22px auto 0;
  width: 260px;
}
.flex-item .echarts_title {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #eee;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.05);
}
.flex-item .echarts_title h2 {
  font-size: 15px;
  font-weight: 700;
  line-height: 50px;
  padding-left: 20px;
  text-align: left;
}
.echrts_div {
  width: 260px;
  height: 186px;
}
.echrts_div1 {
  width: 300px;
  height: 164px;
  padding-top: 10px;
  padding-left: 10px;
}
#echarts_pie1 {
  height: 140px;
}
#echarts_pie3 {
  height: 150px;
}
.pop_words {
  /* display:none; */
  width: 100%;
}
.pop_words_3 {
  float: left;
}
.pop_words .pop_words_3:first-child {
  width: 20%;
}
.pop_words .pop_words_3:nth-child(2) {
  width: 16%;
  margin-left: 5px;
}
.pop_words .pop_words_3:nth-child(3) {
  width: 40%;
  margin-left: 8px;
}
.pop_words .pop_words_3:nth-child(4) {
  width: 22%;
  margin-left: 5px;
}

/*设置头与内容自动对齐*/
table.otherword_list tbody {
  display: block;
  height: 183px;
  overflow-y: scroll;
}
table.otherword_list thead,
tfoot,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
/*给滚动条预留宽度*/
table.otherword_list thead,
tfoot {
  background: #eff0f5;
}
.word_list_head {
  text-align: left;
}
.word_list_head td {
  font-size: 15px;
  font-weight: 700;
  padding: 6px;
  background-color: #6198fe;
  color: #fff;
}
.word_list .word_list_head td:first-child {
  text-align: left;
}
.word_list .word_list_head td:nth-child(2) {
  text-align: center;
}
.otherword_list td {
  text-align: center;
}
.word_list,
.otherword_list {
  margin: 20px 0 0 20px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
  line-height: 27px;
  table-layout: fixed;
}
.word_list tr:nth-child(2n + 1),
.otherword_list tr:nth-child(2n + 1) {
  background-color: #f9fafa;
}
.word_list tr td:first-child {
  padding-left: 22px;
  width: 85px;
  text-align: left;
}
.word_list tr td:nth-child(2) {
  padding-right: 22px;
}
.word_list tr td,
.otherword_list tr td {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pop_words_3 .sentence_list {
  margin: 20px auto;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1), -1px 0 2px rgba(0, 0, 0, 0.05);
  padding: 10px 10px 5px 20px;
  line-height: 25px;
  width: 90%;
}
.pop_words_3 div ul {
  overflow-y: scroll;
  height: 84px;
  margin-top: 6px;
}
.pop_words_3 ul li {
  margin-bottom: 10px;
}
.pop_words_3 ul li span::before {
  margin-right: 10px;
  content: "";
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 18px;
  text-align: center;
  background: #abcdef;
}
.word_list_head {
  font-size: 15px;
  font-weight: 700;
}
td.conjunction_word_count,
td.stopwords_count,
td.foreign_count {
  text-align: left;
}
</style>
